import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, EditIcon, Tooltip } from '@routific/hive/v5';

interface Props {
  show: boolean;
  /** When false, renders the warning chip with only the edit icon (Gantt). */
  withLabel?: boolean;
  tooltipText?: string;
}

const PendingChangesChip: React.FC<Props> = ({
  show,
  withLabel = true,
  tooltipText,
}) => {
  const { t } = useTranslation('components');

  if (!show) {
    return null;
  }

  const title = tooltipText || t('unpublishedChanges.tooltip');
  const label = t('unpublishedChanges.label');

  return (
    <Tooltip title={title}>
      <Chip
        color="warning"
        size="sm"
        startIcon={<EditIcon size="sm" />}
        data-testid="pending-changes-chip"
        aria-label={label}
      >
        {withLabel ? label : undefined}
      </Chip>
    </Tooltip>
  );
};

export default PendingChangesChip;
